import React from 'react';

import useDialog from '../../hooks/useDialog';
import BasicButton from '../Button/BasicButton';

const ConfirmDialog = ({ title, message, cancelText = '취소', confirmText = '확인', handleClose, handleConfirm }) => {
  const { hideDialog } = useDialog();

  const onClose = () => {
    if (handleClose) {
      handleClose();
    }
    hideDialog();
  };

  const onConfirm = async () => {
    if (handleConfirm) {
      await handleConfirm();
    }
  };

  return (
    <div className={'modal-all-wrapper is-show type-dialog'}>
      <div className={'modal-dim-overlay'} />
      <div className='dialog-wrapper'>
        <div className='dialog-msg-group'>
          <h4 className={'dialog-title'}>{title}</h4>
          <p className={'dialog-msg'}>{message}</p>
        </div>
        <div className='dialog-button-group'>
          <BasicButton buttonTxt={cancelText} buttonType={'gray'} buttonSize={'sm'} onClick={onClose} />
          <BasicButton buttonTxt={confirmText} buttonType={'primary'} buttonSize={'sm'} onClick={onConfirm} />
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
